'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumberForm$() {
  this.aQv = null;
  this.aQM = null;
  this.aQy = null;
  this.aQz = false;
  this.aQE = null;
  this.aQF = false;
  this.aQK = null;
  this.aQL = false;
  this.aQw = null;
  this.aQx = false;
  this.aQI = null;
  this.aQJ = false;
  this.aQG = null;
  this.aQH = false;
  this.aQA = null;
  this.aQB = false;
  this.aQC = null;
  this.aQD = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumberForm$ = this;
  this.aQv = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumber$();
  this.aQM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($m_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumber$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumberForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumberForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumberForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumberForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumberForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumberForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumberForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumberForm$.prototype = $p;
$p.eR = (function() {
  return this.aQv;
});
$p.eO = (function() {
  return this.aQM;
});
$p.bW = (function() {
  if ((!this.aQz)) {
    this.aQy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aQz = true;
  }
  return this.aQy;
});
$p.b9 = (function() {
  if ((!this.aQF)) {
    this.aQE = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aQF = true;
  }
  return this.aQE;
});
$p.b3 = (function() {
  if ((!this.aQL)) {
    this.aQK = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aQL = true;
  }
  return this.aQK;
});
$p.aG = (function() {
  if ((!this.aQx)) {
    this.aQw = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aQx = true;
  }
  return this.aQw;
});
$p.az = (function() {
  if ((!this.aQJ)) {
    this.aQI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aQJ = true;
  }
  return this.aQI;
});
$p.aY = (function() {
  if ((!this.aQH)) {
    this.aQG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aQH = true;
  }
  return this.aQG;
});
$p.afl = (function() {
  if ((!this.aQB)) {
    this.aQA = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Seal Number";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aQB = true;
  }
  return this.aQA;
});
$p.bNI = (function() {
  if ((!this.aQD)) {
    this.aQC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().jx;
    this.aQD = true;
  }
  return this.aQC;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumberForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumberForm$, "app.data.data_point_types$package$SealNumberForm$", ({
  Gr: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumberForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumberForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumberForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumberForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumberForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumberForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumberForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumberForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumberForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumberForm$ };
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumber$() {
  this.aQt = null;
  this.aQu = false;
  this.aQr = null;
  this.aQs = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumber$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumber$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumber$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumber$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumber$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumber$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumber$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumber$.prototype = $p;
$p.aA = (function() {
  if ((!this.aQu)) {
    this.aQt = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aQu = true;
  }
  return this.aQt;
});
$p.bNh = (function() {
  if ((!this.aQs)) {
    this.aQr = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumberForm$().afl();
    this.aQs = true;
  }
  return this.aQr;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumber$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumber$, "app.data.data_point_types$package$SealNumber$", ({
  Gq: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumber$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumber$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumber$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumber$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumber$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumber$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumber$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumber$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumber$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$SealNumber$ };
//# sourceMappingURL=app.data.data_point_types$package$-Seal-Number$.js.map
